import FormCroppedImageField from "./fields/Form/CroppedImageField.vue"
import DetailCroppedImageField from "./fields/Detail/CroppedImageField.vue"
import IndexCroppedImageField from "./fields/Index/CroppedImageField.vue"

const croppedImageFieldSetup = (app) => {
    app.component('form-cropped-image-field', FormCroppedImageField)
    app.component('detail-cropped-image-field', DetailCroppedImageField)
    app.component('index-cropped-image-field', IndexCroppedImageField)
}

export { croppedImageFieldSetup }
